<template>
  <div class="cyber-progress">
    <div class="cyber-progress__glow"></div>
    <div class="cyber-progress__body">
      <vc-donut
        background="#1a1a1a"
        class="cyber-progress__donut"
        :size="55"
        unit="%"
        :thickness="12"
        :sections="sections"
      >
        <div class="cyber-progress__value">{{ progress }}%</div>
        <div class="cyber-progress__label">PROGRESS</div>
      </vc-donut>
    </div>
    <div class="cyber-progress__footer">
      <i class="mdi mdi-trending-up"></i>
      <h5>Account Progress</h5>
    </div>
  </div>
</template>

<style scoped>
.cyber-progress {
  background: linear-gradient(135deg, #252525, #2e2e2e);
  border: 1px solid #3d3d37;
  border-radius: 14px;
  margin-bottom: 20px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
}

.cyber-progress:hover {
  border-color: rgba(176, 154, 78, 0.2);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3), 0 0 15px rgba(176, 154, 78, 0.08);
}

.cyber-progress__glow {
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, transparent);
}

.cyber-progress__body {
  padding: 25px 20px;
  text-align: center;
}

.cyber-progress__donut {
  filter: drop-shadow(0 0 12px rgba(176, 154, 78, 0.2));
}

.cyber-progress__value {
  font-family: 'Orbitron', sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #B09A4E;
  line-height: 1.2;
}

.cyber-progress__label {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.5rem;
  color: #9A998F;
  letter-spacing: 0.15em;
}

.cyber-progress__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: #2e2e2e;
  border-top: 1px solid #3d3d37;
}

.cyber-progress__footer i {
  color: #B09A4E;
  font-size: 1.1rem;
}

.cyber-progress__footer h5 {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.7rem !important;
  color: #C2C1B8 !important;
  letter-spacing: 0.1em;
  margin: 0 !important;
}
</style>

<script>
export default {
  data() {
    return {
      progress: this.$store.getters.currentUser.account_progress,
      sections: [
        {
          value: this.$store.getters.currentUser.account_progress,
          color: "#B09A4E",
        },
      ],
    };
  },
};
</script>
